import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';
import { Button, InputGroup, FormControl, Dropdown, DropdownButton, Modal, Form, ButtonGroup } from 'react-bootstrap';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import GenericHelper from '../Tools/GenericHelper';
import Parsers from '../Tools/Parsers';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';

export default class CompanyPage extends PageComponent {

  static PageInfo = {

    path: "/Client",
    name: "menu.clients",
    access: { 1: true },
    permission: { "COMPANY_LIST": true },
    icon: "users"
  }

  static searchTypes = [{}];
  constructor(props) {
    super(props);
    this.state.loading = false;
    this.state.typeSearchLabel = "Nome Fantasia";
    this.state.data = null;
    this.state.isModalVisible = null;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.types = null;
    this.state.loadingsearch = false;
    this.state.company = { name: "", doc: "" };
    this.state.city = null;
    this.state.modalError = null;
    this.state.name1 = null;
    this.state.cnpjCode = null;
    this.state.region = null;
    this.state.selectedBrand = null;
    this.state.selectionType = "name";
    this.state.filter = "";
    this.state.selectedType = null;
    this.state.selectedTypeLabel = null;
    this.path = "Client";
  }

  componentDidMount() {
    this.loadStates();
  }

  loadStates() {
    Connection.Secure(Connection.service + 'State/List/')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {

            Connection.Secure(Connection.service + 'Customer/Types')
              .then((response) => {
                if (response.ok && response.status == 200)
                  response.json().then((data2) => {
                    setTimeout(() => this.setState({ states: data, types: data2 }, this.setState({ loading: false })));
                  });
                else this.setState({ error: response, loading: false });
              })
              .catch((error) => {
                this.setState({ error: error, loading: false });
              });

          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  navigateToNew() {
    this.props.history.push('/' + this.path + '/New');
  }


  changeDropdown(target) {
    this.setState({ selectionType: target, filter: "" });
  }

  loadClients() {
    this.setState({ loadingsearch: true, data: [] });
    Connection.Secure(Connection.service + 'CustomerFK/List' + (this.state.selectedClientType == null ? "" : "/" + this.state.selectedClientType),
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          city: this.state.city, name1: this.state.selectionType == "name" ? this.state.filter : null, customerCode: this.state.selectionType == "customercode" ? this.state.filter : null,
          cnpjCode: this.state.selectionType == "docnumb" ? this.state.filter : null, region: this.state.region
        })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ loadingsearch: false, data: data });
          });
        else this.setState({ error: response, loadingsearch: false });
      })
      .catch((error) => {
        this.setState({ error: error, loadingsearch: false });
      });
  }

  downloadReport(target) {
    var f = target + "_report.xlsx";
    this.setState({ isModalVisible: "downloading", modalInitializing: true });
    Connection.Secure(Connection.service + (target == "users" ?
      'Report/User/' + f :
      target == "customers" ?
        "Report/Customer/" + f :
        target == "results" ?
          "Calculation/Excel/" + this.data.id + "/" + f
          : ""))
      .then(res => res.blob())
      .then(blob => {
        this.setState({ isModalVisible: null });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = f;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
      });
  }

  changeTab(target) {
  }

  handleForm(target) {
  }

  validateDocField() {

  }

  render() {
    return (
      <Container context={this.constructor}>
        {
          this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
            <div className="generics_panels" style={{ flexDirection: "column" }}>
              <div className="generics_panels" style={{ border: "none", padding: 0 }}>
                <div className="generics_panels_sizeless">
                  <div>
                    <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>

                    <MaskedInput type="select" onValid={(value) => this.setState({ selectedClientType: Array.isArray(value) ? value[0] : null })}
                      onInvalid={(value) => this.setState({ selectedClientType: null })} parser={(t, v) => Labels.GetLabel("CLIENT_TYPE." + v, t)} name="bunch,label" data={() => { return this.state.types }} placeholder={Labels.GetLabel("generic.clienttype")} />
                    {
                      window.location.pathname.indexOf('Franchise') > -1 && Array.isArray(this.state.brands) ?
                        <MaskedInput type="select" icon="tag" label={Labels.GetLabel("clientsnew.brandname")} onValid={(value) => this.setState({ selectedBrand: value[0] })}
                          onInvalid={(value) => this.setState({ selectedBrand: null })} name="keyConstant,label" data={this.state.brands} placeholder={Labels.GetLabel("generic.select")} />

                        : null
                    }
                    <InputGroup className="mb-3">
                      <DropdownButton
                        as={InputGroup.Prepend}
                        variant="outline-secondary"
                        title={Labels.GetLabel("generic." + this.state.selectionType)}
                      >
                        <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("name")}>{Labels.GetLabel("generic.name")}</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("docnumb")}>{Labels.GetLabel("generic.docnumb")}</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("customercode")}>{Labels.GetLabel("generic.customercode")}</Dropdown.Item>
                      </DropdownButton>
                      <FormControl aria-describedby="basic-addon1" value={this.state.filter} onChange={(v) => this.setState({ filter: v.currentTarget.value })} />
                    </InputGroup>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "30%", marginRight: 10 }}>
                        <MaskedInput type="select" onValid={(value) => { this.setState({ region: Array.isArray(value) ? value[0] : null }) }}
                          onInvalid={(value) => this.setState({ region: null })} name="label,description" data={() => { return this.state.states }} placeholder={Labels.GetLabel("generic.state")} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <MaskedInput type="text" onValid={(value) => this.setState({ city: value == null ? null : value.normalize("NFD").replace(/[\u0300-\u036f]/g, "") })}
                          onInvalid={(value) => this.setState({ city: null })} placeholder={Labels.GetLabel("generic.city")} />
                      </div>
                    </div>

                    <Button variant="success" block disabled={this.state.loadingsearch} onClick={() => this.loadClients()}>
                      {Labels.GetLabel("clients.pesquisar")}
                    </Button>
                  </div>
                </div>
                <div className="generics_panels_flex1">
                  <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("clients.results")} ({Array.isArray(this.state.data) ? this.state.data.length : 0})</span></div>

                  <div>{
                    this.state.error != null ? <ErrorComponent error={this.state.error} /> :
                      this.state.loadingsearch ? <div>{Labels.GetLabel("generic.loading")}</div> :
                        Array.isArray(this.state.data) && this.state.data.length > 0 ?
                          this.state.data.map((item) => {
                            return <Link to={"/" + this.path + "/Detail/" + item.customerCode} className="generics_listing_item" >
                              <FontAwesomeIcon icon="building" className="generics_listing_item_icon" />
                              <div className="generics_listing_content" >
                                <div>#{item.customerCode}</div>
                                <div className="generics_listing_item_title" >{item.name1 + (item.name2 == null ? "" : item.name2)
                                  + (item.name3 == null ? "" : item.name3)
                                  + (item.name4 == null ? "" : item.name4)}</div>
                                <div className="generics_listing_item_description" >
                                  <div style={{ float: "left" }}>{Parsers.parseCPNJ(item.cnpjCode)}</div>
                                  <div style={{ float: "right", marginLeft: 10 }}>{item.headOfficeAcc != null ? Labels.GetLabel("program.hierarchy_false") + " (#" + item.headOfficeAcc + ")" : Labels.GetLabel("program.hierarchy_true")}</div>
                                  <div style={{ clear: "both" }}></div>
                                </div>
                              </div>
                            </Link>
                          })
                          : this.state.data == null ?
                            <div className="generic_empty">{Labels.GetLabel('generic.fillParameters')}</div>
                            :
                            <div className="generic_empty">{Labels.GetLabel('generic.noresult')}</div>
                  }</div>
                </div>

              </div>
              <div className="generics_actionbar">
                <div>


                  <DropdownButton
                    as={ButtonGroup}
                    key="up"
                    drop="up"
                    variant="primary" style={{ marginRight: 10 }}
                    title={Labels.GetLabel("program.report")}
                    onSelect={(t) => {
                      switch (t) {
                        case "users":
                        case "customers":
                        case "results":
                          this.downloadReport(t);
                          break;
                      }
                    }}
                  >

                    {!Parsers.parsePermission2(["COMPANY_LiST_REPORT"]) ? null :
                      <Dropdown.Item eventKey="users" >{Labels.GetLabel("clientdetail.usersheader")}</Dropdown.Item>
                    }
                    {/* <Dropdown.Item eventKey="customers" >{Labels.GetLabel("login.user1")}</Dropdown.Item> */}
                    {/* <Dropdown.Item eventKey="results" >{Labels.GetLabel("generic.results")}</Dropdown.Item> */}
                  </DropdownButton>
                </div>

                <div style={{ flex: 1 }}></div>
                <div style={{ clear: "both" }}></div>
              </div>
              {/* <div className="generics_floatinbtn" onClick={() => this.navigateToNew()}>
                <FontAwesomeIcon className="generics_floatinbtn_icon" icon="plus" />
              </div> */}

              <Modal
                className={this.state.modalLoading == true ? "modal-loading" : ""}
                onHide={() => { }} show={this.state.isModalVisible != null}
              // onHide={handleClose}
              >
                <div>
                  {
                    this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                      <div>
                        {Labels.GetLabel("adminstategroup.saving")}
                      </div>
                      :
                      <div>
                        <Modal.Header>
                          <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {Labels.GetLabel("clientsnew.confirmation")}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                            {Labels.GetLabel("adminstategroup.closebtn")}
                          </Button>
                          <Button variant="primary" onClick={() => this.addNew()}>
                            {Labels.GetLabel("adminstategroup.savebtn")}
                          </Button>
                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                      </div>
                  }
                </div>
              </Modal>
            </div>
        }
      </Container>
    );
  }
} 